import { connect } from 'react-redux';

import { yourJourneySelectors } from '@store/yourJourney/selectors';
import { basketSelectors } from '@store/basket/selectors';

import { Room } from './Room';

const mapStateToProps = (state) => ({
  journeyParams: yourJourneySelectors.getParsedJourneyParams(state),
  roomIdsInBasket:
    basketSelectors.getBasketDetails(state)?.items?.map((room) => room?.bookable?.ids?.roomId) ||
    [],
});

export const RoomContainer: any = connect(mapStateToProps)(Room);
